(function(){
    document.body.addEventListener('submit', function (event) {
        if (event.target.matches('.chartjs-form')) {
            var form = event.target;
            var id = form.querySelector('canvas').getAttribute('id');

            fetch(form.action, {
                method: 'post',
                body: new FormData(form)
            }).then(res=>res.json())
            .then(function (data) {
                var chart = Chart.getChart(id);
                chart.data.labels = data.labels;

                var datasets = [];
                for (var i = 0; i < data.datasets.length; i++) {
                    var dataset = chart.data.datasets[i];
                    dataset.data = data.datasets[i];
                    datasets.push(dataset);
                }
                chart.data.datasets = [];
                chart.update();

                for (var i = 0; i < datasets.length; i++) {
                    chart.data.datasets.push(datasets[i]);
                }
                chart.update();

                if (data.hasOwnProperty('total')) {
                    form.querySelector('.graph-total').innerHTML = data.total;
                }
                if (data.hasOwnProperty('total_secondary')) {
                    form.querySelector('.graph-total-secondary').innerHTML = data.total_secondary;
                }
            });

            return false;
        }
    });
})();